import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function setUserContext(phone: string) {
  const { data, error } = await supabase.rpc('set_user_context', { 
    user_phone: phone 
  });
  
  if (error) {
    console.error('[SUPABASE] Error setting user context:', error);
    throw error;
  }
  
  console.log('[SUPABASE] User context set for:', phone);
  return { data, error };
}

export async function clearUserContext() {
  try {
    await supabase.rpc('set_user_context', { user_phone: '' });
    console.log('[SUPABASE] User context cleared');
  } catch (error) {
    console.error('[SUPABASE] Error clearing user context:', error);
  }
}
